
import React, { useContext } from "react";
import { get } from "../../../../logics/src/utils/helpers";
import { getCountryMeta } from "layouts/Payment/common/dependencies/dependencyhelpers";
import { PaymentContext } from "wrapper/PaymentWrapper/context/paymentContext";
import { MsgCard } from "components/MsgCard";
import { VERNACULAR_DEFAULT_MESSAGES, VERNACULAR_STRING_IDS } from "constants/vernacularConstants";
import { useHistory } from "react-router-dom";
import { ShippingAddressWrapper } from "./assets/style";
import { getCustomerFirstName, getPlatform } from "shared/helpers";
import { getStringFromId } from "helpers/vernacular";
import { ShippingAddressLoader } from "./common/shippingAddressLoader";
import { CLIENT_URLS } from "constants/urls";
import { doRedirect } from "helpers/utils/redirection";
import { UserContext } from "wrapper/UserWrapper/context";
import { trackChangeOrAddAddressClick } from "layouts/Payment/common/dependencies/tracking";


export interface IShippingAddress {
  addressBarDataTestId?: string, // used for writing test cases
}

const ShippingAddress = (props:IShippingAddress ) => {
  const { addressBarDataTestId } = props;
  const history = useHistory();
  const { userData } = useContext(UserContext);
  const paymentContext = useContext(PaymentContext);
  const platform = getPlatform();

  const shippingAddress = get(paymentContext, "cartInfo.shippingAddress");
  const { isGuest } = userData;

  const handleAddressChangeClick = () => {
    trackChangeOrAddAddressClick({
      url: isGuest ? CLIENT_URLS.NEW_ADDRESS : CLIENT_URLS.SAVED_ADDRESS,
    });
    doRedirect({
      url: isGuest ? CLIENT_URLS.NEW_ADDRESS : CLIENT_URLS.SAVED_ADDRESS,
      history,
      isClientRedirection: true,
    });
  };


  if (!shippingAddress) {
    return <ShippingAddressLoader />;
  }

  const customerName = get(shippingAddress, "firstName");
  const street = get(shippingAddress, "street");
  const city = get(shippingAddress, "city");
  const pincode = get(shippingAddress, "postcode");
  const state = get(shippingAddress, "state");
  const countryCode = get(shippingAddress, "country");
  const phone = get(shippingAddress, "contactNumber");
  let dialCode = "";
  if (countryCode) {
    const countryMeta = getCountryMeta(countryCode);
    dialCode = get(countryMeta, "DIAL_CODE");
  }
  const internationalShippingData = get(paymentContext, "cartInfo.internationalShippingData");
  const communicationText = get(internationalShippingData, "shippingConfigMetaData.international.communicationText");
  const isInternationalShippingApplied = get(internationalShippingData, "isInternationalShippingApplied");
  const cartErrorMessage = get(paymentContext, "cartInfo.cartErrorMessage");

  const DeliverTo = getStringFromId(VERNACULAR_STRING_IDS.DELIVER_TO, VERNACULAR_DEFAULT_MESSAGES.DELIVER_TO);
  const ChangeOrAddAddress = getStringFromId(VERNACULAR_STRING_IDS.CHANGE_OR_ADD_ADDRESS, VERNACULAR_DEFAULT_MESSAGES.CHANGE_OR_ADD_ADDRESS);

  const firstName = getCustomerFirstName(customerName);
  const deliveryTitle = `${firstName}, ${pincode}`;

  return (
    <ShippingAddressWrapper className="layout vertical mrl20">
      <span className="title font-size-16">
        {DeliverTo}
        {" "}
        {deliveryTitle}
      </span>
      <div className="layout vertical address mt8" data-testid = {addressBarDataTestId}>
        <span className="font-size-14"> {street}, {city}, {state}</span>
        <span className="font-size-14">{city}-{pincode}</span>
        <span className="font-size-14">{dialCode}-{phone}</span>
      </div>
      {
        cartErrorMessage && (
          <div className="mt8 error-msg">
            {cartErrorMessage}
          </div>
        )
      }
      <button type="button" className="contained-btn mt16 ptb8" onClick={(e) => {
        e.preventDefault();
        handleAddressChangeClick();
      }}
        data-testid={"change_add_address_btn"}>
        {ChangeOrAddAddress}
      </button>
      {/* International Shipping Address alert msg */}
      {isInternationalShippingApplied && (
        <MsgCard
          extraClass="new-msg-card info-card mtb10 mrl15"
          message={communicationText}
          type="info"
          platform={platform}
        />
      )}
    </ShippingAddressWrapper>
  );
};

export default ShippingAddress;
